export const mockProducts = [
  {
    id: "1",
    title: "Premium Wireless Earbuds Pro X200",
    price: 49.99,
    originalPrice: 89.99,
    image: "https://public.readdy.ai/ai/img_res/21255a2c1532bd7ae16d4cc60225bf53.jpg",
    seller: "TechVision Factory",
    sellerAvatar: "https://readdy.ai/api/search-image?query=modern%20tech%20company%20logo%20icon%20blue%20circle%20professional&width=40&height=40&seq=av1&orientation=squarish",
    verified: true,
    rating: 4.8,
    reviews: 2341,
    category: "Electronics",
    badge: "Best Seller",
    stock: 500,
  },
  {
    id: "2",
    title: "Organic Cotton Oversized Hoodie",
    price: 34.99,
    originalPrice: 59.99,
    image: "https://readdy.ai/api/search-image?query=organic%20cotton%20oversized%20hoodie%20beige%20cream%20color%20folded%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod2&orientation=squarish",
    seller: "GreenThread Mills",
    sellerAvatar: "https://readdy.ai/api/search-image?query=green%20leaf%20textile%20company%20logo%20icon&width=40&height=40&seq=av2&orientation=squarish",
    verified: true,
    rating: 4.6,
    reviews: 1892,
    category: "Fashion",
    badge: "Eco Friendly",
    stock: 1200,
  },
  {
    id: "3",
    title: "Smart LED Desk Lamp with USB-C",
    price: 28.99,
    originalPrice: 45.00,
    image: "https://readdy.ai/api/search-image?query=modern%20smart%20LED%20desk%20lamp%20white%20minimalist%20design%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod3&orientation=squarish",
    seller: "LightCraft Industries",
    sellerAvatar: "https://readdy.ai/api/search-image?query=light%20bulb%20company%20logo%20orange%20circle%20icon&width=40&height=40&seq=av3&orientation=squarish",
    verified: true,
    rating: 4.7,
    reviews: 987,
    category: "Home",
    badge: "New Arrival",
    stock: 800,
  },
  {
    id: "4",
    title: "Vitamin C Brightening Serum 30ml",
    price: 19.99,
    originalPrice: 38.00,
    image: "https://readdy.ai/api/search-image?query=vitamin%20C%20brightening%20serum%20glass%20bottle%20skincare%20product%20clean%20white%20background%20minimalist%20photography&width=400&height=400&seq=prod4&orientation=squarish",
    seller: "PureGlow Labs",
    sellerAvatar: "https://readdy.ai/api/search-image?query=beauty%20skincare%20brand%20logo%20pink%20circle%20icon&width=40&height=40&seq=av4&orientation=squarish",
    verified: true,
    rating: 4.9,
    reviews: 3210,
    category: "Beauty",
    badge: "Top Rated",
    stock: 2000,
  },
  {
    id: "5",
    title: "Stainless Steel Water Bottle 32oz",
    price: 22.99,
    originalPrice: 35.00,
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20insulated%20water%20bottle%20matte%20black%20clean%20white%20background%20product%20photography%20studio&width=400&height=400&seq=prod5&orientation=squarish",
    seller: "HydroForge Co.",
    sellerAvatar: "https://readdy.ai/api/search-image?query=water%20drop%20company%20logo%20teal%20circle%20icon&width=40&height=40&seq=av5&orientation=squarish",
    verified: true,
    rating: 4.5,
    reviews: 1567,
    category: "Sports",
    badge: "Popular",
    stock: 3000,
  },
  {
    id: "6",
    title: "Portable Bluetooth Speaker IPX7",
    price: 39.99,
    originalPrice: 69.99,
    image: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20cylindrical%20black%20waterproof%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod6&orientation=squarish",
    seller: "SoundWave Factory",
    sellerAvatar: "https://readdy.ai/api/search-image?query=sound%20wave%20music%20company%20logo%20purple%20circle%20icon&width=40&height=40&seq=av6&orientation=squarish",
    verified: true,
    rating: 4.7,
    reviews: 2089,
    category: "Electronics",
    badge: "Flash Sale",
    stock: 450,
  },
  {
    id: "7",
    title: "Bamboo Cutting Board Set (3-Pack)",
    price: 24.99,
    originalPrice: 42.00,
    image: "https://readdy.ai/api/search-image?query=bamboo%20cutting%20board%20set%20three%20sizes%20kitchen%20clean%20white%20background%20product%20photography%20minimalist&width=400&height=400&seq=prod7&orientation=squarish",
    seller: "EcoKitchen Works",
    sellerAvatar: "https://readdy.ai/api/search-image?query=bamboo%20leaf%20kitchen%20brand%20logo%20green%20icon&width=40&height=40&seq=av7&orientation=squarish",
    verified: false,
    rating: 4.4,
    reviews: 743,
    category: "Home",
    badge: "",
    stock: 1500,
  },
  {
    id: "8",
    title: "Resistance Bands Set 5-Level",
    price: 16.99,
    originalPrice: 29.99,
    image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20colorful%20five%20levels%20fitness%20exercise%20clean%20white%20background%20product%20photography&width=400&height=400&seq=prod8&orientation=squarish",
    seller: "FitForge Manufacturing",
    sellerAvatar: "https://readdy.ai/api/search-image?query=fitness%20dumbbell%20brand%20logo%20red%20circle%20icon&width=40&height=40&seq=av8&orientation=squarish",
    verified: true,
    rating: 4.6,
    reviews: 4521,
    category: "Sports",
    badge: "Hot Deal",
    stock: 5000,
  },
];

export const mockCategories = [
  { id: "all", label: "All", icon: "ri-apps-line" },
  { id: "electronics", label: "Electronics", icon: "ri-smartphone-line" },
  { id: "fashion", label: "Fashion", icon: "ri-t-shirt-line" },
  { id: "home", label: "Home", icon: "ri-home-line" },
  { id: "beauty", label: "Beauty", icon: "ri-heart-line" },
  { id: "sports", label: "Sports", icon: "ri-run-line" },
];
